<template lang="pug">
    div
        List
            ListItem(v-for="(originPolicy, index) in value" :key="index")
                ListItemMeta(
                    :title="originPolicy.regionName.join(',')"
                    :description="`policy: ${originPolicy.originPolicyName}`"
                )
                template(slot="action")
                    Button(@click="editOriginPolicy(editOriginPolicyData.regionName, index)") {{ $t("rcmtable.editText")}}
                    Button(@click="removeOriginPolicy(index)") {{ $t("rcmtable.deleteText")}}
            Button(@click="addOriginPolicy") {{ $t("rcmtable.addTagText")}}
        Modal(v-model="isAddOriginPolicyModalShow" title="Add Region and Policy" :mask-closable="false")
            Form(ref="createForm" :model="addOriginPolicyData" v-if="isAddOriginPolicyModalShow")
                FormItem(prop="regionName")
                    FormSelect(
                        v-model="addOriginPolicyData.regionName"
                        :formData="addOriginPolicyData"
                        :formItem="regionNameSelectorOptions"
                        style="width:200px")
                FormItem(prop="originPolicyName")
                    FormSelect(
                        v-model="addOriginPolicyData.originPolicyName"
                        :formData="addOriginPolicyData"
                        :formItem="originPolicySelectorOptions"
                        style="width:200px")
            div(slot="footer")
              Button(@click="confirmAddOriginPolicy") {{$t('rcmtable.confirmText')}}
              Button(@click="cancelAddOriginPolicy") {{$t('rcmtable.cancelText')}}
        Modal(v-model="isEditOriginPolicyModalShow" title="Edit policy"  :mask-closable="false")
            Form(ref="editForm" :model="editOriginPolicyData" v-if="isEditOriginPolicyModalShow")
                FormItem(prop="originPolicyName")
                    FormSelect(
                        v-model="editOriginPolicyData.originPolicyName"
                        :formData="editOriginPolicyData"
                        :formItem="originPolicySelectorOptions"
                        style="width:200px")
            div(slot="footer")
              Button(@click="confirmEditOriginPolicy") {{$t('rcmtable.confirmText')}}
              Button(@click="cancelEditOriginPolicy") {{$t('rcmtable.cancelText')}}
</template>
<script>
import { getFormOptions } from "@/api/formoptions";
import FormSelect from "@/components/rcmTableFormItems/Select/index.js";
const countryCode = require("@/data/countryCode");

export default {
    name: "OriginPolicySelector",
    components: { FormSelect },
    props: {
        value: {
            default: () => [],
        },
        editingItems: {
            default: () => [],
        },
    },
    watch: {
        value: function (newVal, oldVal) {
            this.$emit("input", newVal);
        },
        // 給定Array無法直接被watch, 使用computed先轉成JSON string
        editingItems_str: function (newVal_str, oldVal_str) {
            let oldVal = JSON.parse(oldVal_str);
            let newVal = JSON.parse(newVal_str);
            let oldGroupNames = JSON.stringify(oldVal.items.map((e) => e.groupName));
            let newGroupNames = JSON.stringify(newVal.items.map((e) => e.groupName));
            if (oldGroupNames !== newGroupNames) {
                // getFormOptions(
                //     `/groupby/origin-policies-region?groupName=${this.editingItems.items[0].groupName}&withDefault=true`
                // ).then(res => {
                //     this.originRegionOptions = res.data.options;
                // });
                let groupName =
                    this.editingItems.items !== undefined
                        ? this.editingItems.items[0].groupName
                        : this.editingItems.groupName;
                getFormOptions(`/originpolicynames?groupNames=${groupName}`).then((res) => {
                    this.originPolicyNameOptions = res.data.options;
                });
            }
        },
    },
    data() {
        return {
            originPolicyNameOptions: [],
            isAddOriginPolicyModalShow: false,
            isEditOriginPolicyModalShow: false,
            regionNameSelectorOptions: {
                placeholder: this.$i18n.t("main.selectPlaceholder"),
                options: [{ label: "Default", value: "default" }, ...countryCode],
                multiple: true,
                queryParamsFields: [{ fieldName: "groupName", queryIf: (val) => val !== "" }],
                defaultVal: "",
            },
            originPolicySelectorOptions: {
                placeholder: this.$i18n.t("main.selectPlaceholder"),
                options: [],
                remoteOptions: async (queryValue, queryParams) => {
                    queryValue = queryValue || "*";
                    queryParams.groupName =
                        this.editingItems.items !== undefined
                            ? this.editingItems.items[0].groupName
                            : this.editingItems.groupName;
                    queryParams.originPolicyName = `*${queryValue}*`;
                    let queryString = new URLSearchParams(queryParams).toString();
                    let result = await getFormOptions(`originpolicynames?${queryString}`);
                    return result.data.options;
                },
                queryParamsFields: [{ fieldName: "groupName", queryIf: (val) => val !== "" }],
                defaultVal: "",
            },
            addOriginPolicyData: { regionName: "", originPolicyName: "" },
            editOriginPolicyData: { regionName: "", originPolicyName: "" },
            originPolicy: { regionName: ["default"], originPolicyName: "" },
            editingOriginPolicyIndex: 0,
        };
    },
    computed: {
        editingItems_str() {
            return JSON.stringify(this.editingItems);
        },
    },
    methods: {
        addOriginPolicy() {
            this.isAddOriginPolicyModalShow = true;
            this.addOriginPolicyData.regionName = ["default"];
        },
        confirmAddOriginPolicy() {
            // 如果初次添加不是Array, 先轉成Array
            this.value = Array.isArray(this.value) ? this.value : [];

            let selectedRegionNames = this.value.map((e) => e.regionName);
            selectedRegionNames = [].concat.apply([], selectedRegionNames);
            selectedRegionNames = [...new Set(selectedRegionNames)];

            let existRegion = selectedRegionNames.filter((regionName) =>
                this.addOriginPolicyData.regionName.includes(regionName)
            );
            if (existRegion.length > 0) {
                return this.$Message.warning("Region exist: " + existRegion);
            }
            if (
                this.addOriginPolicyData.regionName.length == 0 ||
                this.addOriginPolicyData.originPolicyName.length == 0
            ) {
                return this.$Message.warning("Missing region or policy");
            }

            this.value.push(Object.assign(this.addOriginPolicyData, {}));
            this.cancelAddOriginPolicy();
        },
        cancelAddOriginPolicy() {
            this.addOriginPolicyData = { regionName: ["default"], originPolicyName: "" };
            this.isAddOriginPolicyModalShow = false;
            this.$emit("modalSubmitComplete");
        },
        confirmEditOriginPolicy() {
            this.isEditOriginPolicyModalShow = false;
        },
        cancelEditOriginPolicy() {
            this.$refs.editForm.resetFields();
            this.isEditOriginPolicyModalShow = false;
        },
        removeOriginPolicy(index) {
            this.value.splice(index, 1);
        },
        onRegionNameChange(regionName) {},
        editOriginPolicy(regionName, index) {
            this.editingOriginPolicyIndex = index;
            this.editOriginPolicyData = this.value[index];
            this.isEditOriginPolicyModalShow = true;
        },
    },
    created() {},
    destroyed() {},
    beforeDestroy() {},
};
</script>



// WEBPACK FOOTER //
// src/components/FormItems/OriginPolicySelector.vue